import { API_BASE } from './config';

// =============================================================================
// 플레이어 미리보기 URL 빌더 — 관리자 화면에서 새 창으로 read-only 플레이어를 연다.
// dev(admin 5173)에서는 player(5174)로, 배포에서는 /player/ 경로로 연결한다.
// =============================================================================

function buildPreviewUrl(search: string): string {
  const current = new URL(window.location.href);
  if (current.port === '5173') {
    // dev: admin 5173 → player 5174
    current.port = '5174';
    current.pathname = '/';
    current.search = search;
    current.hash = '';
    return current.toString();
  }
  return new URL(`/player/${search}`, API_BASE).toString();
}

/** 디바이스 read-only 미리보기 (nowPlaying 흐름 그대로). */
export function playerPreviewUrl(deviceId: string): string {
  return buildPreviewUrl(`?preview=device&deviceId=${encodeURIComponent(deviceId)}`);
}

/** 플레이리스트 read-only 미리보기. */
export function playlistPreviewUrl(playlistId: string): string {
  return buildPreviewUrl(`?preview=playlist&playlistId=${encodeURIComponent(playlistId)}`);
}

export function contentPreviewUrl(kind: 'media' | 'notice' | 'playlist', id: string): string {
  return buildPreviewUrl(`?preview=content&kind=${kind}&id=${encodeURIComponent(id)}`);
}
